module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-cards"
  }, [_c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.totalProducts.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Total Products")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.costsSet.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Costs Set")]), _vm._v(" "), _c('div', {
    staticClass: "stat-percentage"
  }, [_vm._v("(" + _vm._s(_vm.statistics.percentageSet) + "%)")])]), _vm._v(" "), _c('div', {
    staticClass: "stat-card"
  }, [_c('div', {
    staticClass: "stat-value"
  }, [_vm._v(_vm._s(_vm.statistics.missingCosts.toLocaleString()))]), _vm._v(" "), _c('div', {
    staticClass: "stat-label"
  }, [_vm._v("Missing Costs")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c108871!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricing-costs/StatisticsCards.vue
// module id = 780
// module chunks = 2